import React from 'react';

var SvgChevronRightLg = function SvgChevronRightLg(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.18 18.82c-.24-.24-.24-.628 0-.868l5.952-5.952-5.952-5.952c-.24-.24-.24-.628 0-.868s.628-.24.868 0l6.386 6.386c.115.115.18.271.18.434s-.065.319-.18.434l-6.386 6.386c-.24.24-.628.24-.868 0",
    clipRule: "evenodd"
  }));
};
SvgChevronRightLg.displayName = "ChevronRightLg";

export { SvgChevronRightLg as S };
